//true new version
export const FEATURE_TOGGLE_CORE = {
  QUOTATIONS_STATUS: true,
};
